import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Show, SimpleShowLayout, RichTextField, DateField, AutocompleteInput, NumberInput, ArrayInput, SimpleFormIterator, List, Datagrid, TextField, ReferenceField, EditButton, Edit, SimpleForm, ReferenceInput, TextInput, SelectInput, DisabledInput, LongTextInput, Create, Filter } from 'react-admin';

/*const PostTitle = ({ record }) => {
	return <span>Post {record ? `${record.title}` : ''}</span>;
}*/
const ProductTitle = ({ record }) => {
	return <span>{record ? `${record.name}` : ''}</span>;
}
const DescriptionField = ({ record = {} }) => {
	var summary = "";
	if ("description" in record &&
		Array.isArray(record["description"]) == true &&
		record["description"].length > 0 &&
		"title" in record["description"][0]) {
		summary = record["description"][0]["title"];
	}
	return (<span>{summary}</span>);
};
const PriceField = ({ source, record = {} }) => {
	var price = "";
	if (source in record) {
		if ("amount" in record[source]) {
			price = price + record[source]["amount"];
		}
		if ("currency" in record[source]) {
			price = price + " " + String(record[source]["currency"]);
		}
	}
	return (<span>{price}</span>);
};
PriceField.propTypes = {
	label: PropTypes.string,
	record: PropTypes.object,
	source: PropTypes.string.isRequired,
};
const currencyOptions = [
	{ _id: 1, text: 'KRW(한화)', value: 'KRW' },
	{ _id: 2, text: 'USD(미화)', value: 'USD' }
]
DescriptionField.defaultProps = { label: '소개문' };
/*const PostFilter = (props) => (
	<Filter {...props}>
		<TextInput label="Search" source="q" alwaysOn />
		<ReferenceInput label="User" source="userId" reference="users" allowEmpty>
			<SelectInput optionText="name" />
		</ReferenceInput>
	</Filter>
);*/
export const ProductShow = props => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="name" />
			<DateField label="등록일시" source="created_at" />
		</SimpleShowLayout>
	</Show>
);
export const ProductList = props => (
	<List /*filters={<PostFilter />}*/ {...props} title="제품목록">
		<Datagrid rowClick="show">
			<TextField source="id" label="일련번호" />
			<TextField source="created_at" label="등록일시" />
			<TextField source="name" label="제품명" />
			<DescriptionField source="description" label="소개문" />
			<PriceField source="normal_price" label="일반제공가격" />
			<PriceField source="offered_price" label="할인제공가격" />
			<EditButton />
		</Datagrid>
	</List>
)
export const ProductEdit = props => (
	<Edit title={<ProductTitle />} {...props}>
		<SimpleForm>
			<DisabledInput source="id" />
			<DisabledInput source="created_at" />
			<TextInput source="name" />
			<ArrayInput label="소개문" source="description">
				<SimpleFormIterator>
					<TextInput label="제목" source="title" />
					<TextInput label="내용" source="paragraph" />
				</SimpleFormIterator>
			</ArrayInput>
			<NumberInput label="일반제공가격" source="normal_price.amount" />
			<AutocompleteInput label="일반제공가격통화" source="normal_price.currency" choices={currencyOptions} optionText="text" optionValue="value" />
			<NumberInput label="할인제공가격" source="offered_price.amount" />
			<AutocompleteInput label="할인제공가격통화" source="offered_price.currency" choices={currencyOptions} optionText="text" optionValue="value" />
		</SimpleForm>
	</Edit>
)
export const ProductCreate = props => (
	<Create {...props}>
		<SimpleForm>
			<TextInput source="name" />
		</SimpleForm>
	</Create>
)
/*export const PostEdit = props => (
	<Edit title={<PostTitle />} {...props}>
		<SimpleForm>
			<DisabledInput source="id" />
			<ReferenceInput source="userId" reference="users"><SelectInput optionText="name" /></ReferenceInput>
			<TextInput source="title" />
			<LongTextInput source="body" />
		</SimpleForm>
	</Edit>
);
export const PostCreate = props => (
	<Create {...props}>
		<SimpleForm>
			<ReferenceInput source="userId" reference="users">
				<SelectInput optionText="name" />
			</ReferenceInput>
			<TextInput source="title" />
			<LongTextInput source="body" />
		</SimpleForm>
	</Create>
)*/